import { useQuery } from '@tanstack/react-query';
import { Globe } from 'lucide-react';
import { getCrossProjectIntelligence } from '@/lib/api';

/**
 * PortfolioOverviewPanel
 *
 * Shows total projects, total patterns, and most active project
 */
export function PortfolioOverviewPanel(): React.ReactElement | null {
  const { data, isLoading } = useQuery({
    queryKey: ['intelligence'],
    queryFn: getCrossProjectIntelligence,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });

  if (isLoading) {
    return <div className="text-xs text-text-secondary">Loading portfolio overview...</div>;
  }

  if (!data) {
    return null;
  }

  const mostActive = [...data.projects].sort((a, b) => b.patternCount - a.patternCount)[0];

  return (
    <div className="space-y-2">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-text-tertiary flex items-center gap-1">
        <Globe className="h-3.5 w-3.5" />
        Portfolio Overview
      </div>

      <div className="space-y-1.5 text-xs">
        <div className="flex items-center justify-between">
          <span className="text-text-secondary">Projects</span>
          <span className="font-semibold text-text-primary">{data.projects.length}</span>
        </div>

        <div className="flex items-center justify-between">
          <span className="text-text-secondary">Total Patterns</span>
          <span className="font-semibold text-text-primary">{data.totalPatterns}</span>
        </div>

        {mostActive && (
          <div className="pt-1 border-t border-border/50">
            <div className="text-[10px] text-text-tertiary mb-0.5">Most Active</div>
            <div className="text-xs text-text-primary font-medium truncate">{mostActive.name}</div>
            <div className="text-[9px] text-text-tertiary">{mostActive.patternCount} patterns</div>
          </div>
        )}
      </div>
    </div>
  );
}
